module.exports = __webpack_public_path__ + "platform-web/static/media/dropup.27f5e99b.svg";